import { Article, P } from '@slal/ui/typography';
import { MaxWidthContent } from '~/components';
import { CashLikeFundDeclarationForm } from './CashLikeFundDeclarationForm';
import { CashLikeFundsWarningHeading } from './styles';

export const CashLikeFundsWarning = () => {
    return (
        <MaxWidthContent>
            <Article>
                <CashLikeFundsWarningHeading level={3}>
                    A significant part of your remaining pot will be invested in a cash like (money market) fund
                </CashLikeFundsWarningHeading>
                <P>
                    Since these investments are lower risk, they're less likely to be affected by the ups and downs of
                    financial markets and as a result, your money may not grow enough to meet your needs.
                </P>

                <P>
                    This is especially important when you take into account inflation, which affects how much things
                    cost. If your pension pot doesn't grow as much as the rate of inflation, it won't be able to buy you
                    as much as it would today. If you continue with your selection, we'll send you a letter in the post
                    that will help illustrate the impact to you.
                </P>

                <P>
                    It's important to remember they can still fall in value and you could get back less than what was
                    paid in.
                </P>

                <P>We recommend seeking guidance or advice to understand your options.</P>
            </Article>

            <CashLikeFundDeclarationForm />
        </MaxWidthContent>
    );
};
